export default __webpack_public_path__ + "static/media/logo-no-text-halloween.eb866100.svg";